import { Input, Upload, UploadFile } from 'antd'

import './InspectionReportDrawer.style.less'
import { camelCase, find, size, startCase, values } from 'lodash'
import { useEffect, useState } from 'react'
import { RcFile, UploadProps } from 'antd/lib/upload'

type Props = {
  name: string
  addNewPhotoKey: string
  photoSelected: any
  value: any
  onChange: (e) => void
}

interface FileListType extends UploadFile {
  originalId?: string
  original_path?: string
  comment?: string
}
function EditPhotoComponent(props: Props) {
  const [stateFileList, setStateFileList] = useState<FileListType[]>([])
  const [stateComments, setStateComments] = useState<string>('')

  // EVEN FUNCTION
  const onCommentChangeFN = (event) => {
    if (event?.target) {
      setStateComments(event?.target?.value)
    }
  }

  const handleImageChange: UploadProps['onChange'] = ({
    fileList: newFileList,
  }) => {
    setStateFileList(newFileList)
  }

  const handlePreview = async () => {
    let src = stateFileList[0].original_path as string
    if (!src) {
      src = await new Promise((resolve) => {
        const reader = new FileReader()
        reader.readAsDataURL(stateFileList[0].originFileObj as RcFile)
        reader.onload = () => resolve(reader.result as string)
      })
    }
    const image = new Image()
    image.src = src
    const imgWindow = window.open(src)
    imgWindow?.document.write(image.outerHTML)
  }

  const handlePreparePayload = () => {
    const { photoSelected, value, addNewPhotoKey } = props
    let getMediaBaseId = ''

    if (size(photoSelected)) {
      const getImage = find(
        value.value,
        (item) => item.thumbnailId === photoSelected.thumbnailId
      )
      getMediaBaseId = getImage?.originalId
    }
    setTimeout(() => {
      const wrapUpdated = {
        ...values(stateFileList)[0],
        originalId: getMediaBaseId, // id of the current image
        comment: stateComments,
        isUpdate: !size(addNewPhotoKey), // Custom field refer to edit photo
      }
      props.onChange(wrapUpdated)
    }, 500)
  }

  useEffect(() => {
    if (size(stateFileList)) {
      handlePreparePayload()
    }
  }, [stateComments, stateFileList])

  useEffect(() => {
    const { photoSelected } = props
    const { value } = props?.value
    const getImage = find(
      value,
      (item) => item.thumbnailId === photoSelected?.thumbnailId
    )

    if (size(getImage)) {
      const wrapImage: FileListType = {
        url: getImage.original_path,
        ...getImage,
      }

      setStateFileList([wrapImage])
      setStateComments(wrapImage.comment)
    }
  }, [props.value, props.photoSelected])

  const title = props?.value?.title || ''
  const displayLabel = (
    <p className="item-entry-number">
      {startCase(camelCase(title || props.name))}
    </p>
  )

  return (
    <div className="group-photo-container">
      {displayLabel}
      <p className="title">Photo</p>
      <Upload
        className="edit-photo-item"
        listType="picture-card"
        maxCount={1}
        accept="image/png, image/jpeg, image/jpg, image/bmp, image/webp"
        fileList={stateFileList}
        method={'GET' as any}
        beforeUpload={() => false}
        onPreview={handlePreview}
        onChange={handleImageChange}
      >
        {size(stateFileList) ? null : 'Upload'}
      </Upload>
      <div>
        <p className="title">Comment</p>
        <Input.TextArea
          autoSize
          size="large"
          value={stateComments}
          onChange={onCommentChangeFN}
        />
      </div>
    </div>
  )
}

export default EditPhotoComponent
